import React, { useState, useContext } from 'react';

export interface CalculatePriceContextInterface {
  calculatePrice?: Billing.IPrice;
  setCalculatePrice?: (product: Billing.IPrice) => void;
}

const CalculatePriceContext = React.createContext<CalculatePriceContextInterface>({});

export const CalculatePriceContextProvider: React.FunctionComponent = ({ children }) => {
  const [calculatePrice, setCalculatePrice] = useState();

  return (
    <CalculatePriceContext.Provider value={{ calculatePrice, setCalculatePrice }}>
      {children}
    </CalculatePriceContext.Provider>
  );
};

export const CalculatePriceContextConsumer = CalculatePriceContext.Consumer;

export const useCalculatePrice = () => useContext(CalculatePriceContext);

export default CalculatePriceContext;
